import ICON, { icon, SVGPATH } from '../../../SVG/icon/ICON.js';
import { svg } from '../../../DOM/svg/SVG.js';
import SVGCIRCLE, { svgCircleAttr, svgCircleModel } from '../../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGCIRCLE.js';
import { svgPathAttr, svgPathModel } from '../../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGPATH.js';
export default class ICON_LOGO extends ICON {
    constructor(node) {
        super(node, icon(svg()));
        this.svg.addChild(new SVGCIRCLE(this.svg, svgCircleModel(svgCircleAttr('256', '256', '256', '#FFF'))));
        this.svg.addChild(new SVGPATH(this.svg, svgPathModel(svgPathAttr('M504.01,256.18c0-137.07-111.04-248.18-248.01-248.18S7.99,119.11,7.99,256.18s103.81,240.8,234.5,247.81l3.96-122.84c3.59-29.13-73.84-31.6-73.84-117.23s39.8-151.36,80.83-152.19c42.32-.86,85.94,68.31,85.94,154.6,0,78.19-67.34,77.15-72.73,115.59l2.71,122.08c130.76-6.95,234.64-115.25,234.64-247.82Z', 'none', 'currentColor', 'fill-rule: evenodd'))));
    }
}
